<script setup lang="ts">
withDefaults(defineProps<{
  readonly kicker: string | null
  readonly title: string
  readonly sub: string | null
  readonly variant?: 'customer' | 'personnel'
}>(), { variant: 'customer' })
</script>

<template>
  <div
    class="fw-welcome-headline"
    :class="{ 'fw-welcome-headline--personnel': variant === 'personnel' }"
  >
    <component
      :is="variant === 'personnel' ? 'div' : 'p'"
      v-if="kicker"
      class="fw-welcome-headline__kicker"
    >
      {{ kicker }}
    </component>
    <h2 v-if="variant === 'personnel'">
      {{ title }}
    </h2>
    <h1 v-else>
      {{ title }}
    </h1>
    <p
      v-if="sub"
      class="fw-welcome-headline__sub"
    >
      {{ sub }}
    </p>
  </div>
</template>

<style scoped>
.fw-welcome-headline {
  max-width: 36ch;
}

.fw-welcome-headline__kicker {
  /* FW-145 tur 2 — design/current/Auth v2.dc.html satir 50: kicker
     class="mono" tasir; --fw-font-mono tokens.css'te TANIMLI ama bu
     bilesende hic TUKETILMIYORDU (koordinator bulgusu). */
  font-family: var(--fw-font-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);
  margin: 0 0 12px;
}

/* FW-150 — design/current/Auth v2.dc.html satir 419: script'teki
 * `titleStyle` string'i `text-wrap:balance` de tasir, ama bu deger CSS'e
 * hic KOPYALANMAMISTI (koordinator bulgusu). Sonuc OLCULDU (auth-stg.
 * fusapp.work, 1440x1000): tarayicinin ac-gozlu (greedy) satir kirma
 * algoritmasi basligi "İşinizin tamamı, tek / yerde." diye kiriyordu —
 * onayli artboard'daki (auth__01-giris-eposta.png) "İşinizin tamamı, /
 * tek yerde." DEGIL. `balance` iki satirin genisligini esitlemeye
 * calisir; ayni genislikte kap + ayni metinle kirilma noktasi degisir. */
.fw-welcome-headline h1 {
  font-size: clamp(24px, 2.6vw, 32px);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.025em;
  margin: 0;
  text-wrap: balance;
}

.fw-welcome-headline__sub {
  font-size: clamp(13.5px, 1.35vw, 15.5px);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.8);
  margin: 14px 0 0;
}
/* FW-224 — personel onayindaki h2/40px, musteri h1/32px ile aynilastirilmaz. */
.fw-welcome-headline h2 {
  margin: 0;
  font-size: clamp(28px, 3.4vw, 40px);
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -0.025em;
  text-wrap: balance;
}
.fw-welcome-headline--personnel .fw-welcome-headline__sub { text-wrap: pretty; }
</style>
